import type { IEntitiesStore } from 'entities/EntitiesExport'

const SAMPLE_RATE = 60000
let timeout: ReturnType<typeof setTimeout>

export const eventHeartbeat = (entities: IEntitiesStore) => {
  entities.dataLogStore.setItem({
    logLevel: 'info',
    message: 'Heartbeat',
  })

  if (timeout) clearTimeout(timeout)

  timeout = setTimeout(() => {
    eventHeartbeat(entities)
  }, SAMPLE_RATE)
}
